'use strict'

module.exports = require('@itsfadnis/jsonapi-client/dist/model')
